import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-overlay-mask',
  template: ' ',
  styleUrls: ['overlay-mask.component.scss'],
  host: {
    '[class.visible-state]': '!!visible',
    '[class.animation-enabled]': '!!animationEnabled',
    '[style.--overlay-mask-color]': 'maskColor',
  },
})
export class OverlayMaskComponent {
  @Input()
  visible: boolean;

  @Input()
  maskColor = 'rgba(0, 0, 0, 0.64)';

  @Input()
  animationEnabled = true;
}
